import axios from 'axios';
import {setStore} from "../utils/util";
import {store} from "../vuex/store";

//axios.defaults.baseURL = 'https://www.bkdhsc.cn:15838';
// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({

        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('token')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

axios.interceptors.response.use(
  response => {
    // 对响应数据做些什么，例如检查状态码
    return response;
  },
  error => {
    // 对响应错误做些什么，例如检查状态码
    if (error.response.status === 401) {
      setStore("idAdmin","");
      setStore("accountAdmin","");
      setStore("tokenAdmin","");
      setStore("id","");
      setStore("account","");
      setStore("token","");
      //console.error('401 Unauthorized  123');
    }
    return Promise.reject(error);
  }
);

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js